"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var CountryCodes = {
  US: 'country.us',
  CA: 'country.ca',
  AD: 'country.ad',
  AL: 'country.al',
  AM: 'country.am',
  AZ: 'country.az',
  AT: 'country.at',
  BA: 'country.ba',
  BE: 'country.be',
  BG: 'country.bg',
  BY: 'country.by',
  CH: 'country.ch',
  CY: 'country.cy',
  CZ: 'country.cz',
  DK: 'country.dk',
  DE: 'country.de',
  DZ: 'country.dz',
  EE: 'country.ee',
  EG: 'country.eg',
  ES: 'country.es',
  FO: 'country.fo',
  FI: 'country.fi',
  FR: 'country.fr',
  GB: 'country.gb',
  GE: 'country.ge',
  GI: 'country.gi',
  GR: 'country.gr',
  HR: 'country.hr',
  HU: 'country.hu',
  IE: 'country.ie',
  IL: 'country.il',
  IS: 'country.is',
  IT: 'country.it',
  JO: 'country.jo',
  LB: 'country.lb',
  LI: 'country.li',
  LT: 'country.lt',
  LU: 'country.lu',
  LV: 'country.lv',
  LY: 'country.ly',
  MA: 'country.ma',
  MC: 'country.mc',
  MD: 'country.md',
  ME: 'country.me',
  MK: 'country.mk',
  MT: 'country.mt',
  NL: 'country.nl',
  NO: 'country.no',
  PL: 'country.pl',
  PS: 'country.ps',
  PT: 'country.pt',
  RO: 'country.ro',
  RS: 'country.rs',
  RU: 'country.ru',
  SE: 'country.se',
  SI: 'country.si',
  SK: 'country.sk',
  SM: 'country.sm',
  SY: 'country.sy',
  TN: 'country.tn',
  TR: 'country.tr',
  UA: 'country.ua',
  // Latin America & Caribbean (NPI-2756)
  MX: 'country.mx',
  BR: 'country.br',
  PE: 'country.pe',
  AR: 'country.ar',
  CL: 'country.cl',
  CO: 'country.co',
  GT: 'country.gt',
  EC: 'country.ec',
  CR: 'country.cr',
  HN: 'country.hn',
  DO: 'country.do',
  PR: 'country.pr',
  SV: 'country.sv',
  PA: 'country.pa',
  TT: 'country.tt',
  BO: 'country.bo',
  UY: 'country.uy',
  JM: 'country.jm',
  BS: 'country.bs',
  NI: 'country.ni',
  GY: 'country.gy',
  BB: 'country.bb',
  PY: 'country.py',
  SR: 'country.sr',
  LC: 'country.lc',
  VI: 'country.vi',
  VE: 'country.ve',
  AW: 'country.aw',
  KY: 'country.ky',
  TC: 'country.tc',
  AG: 'country.ag',
  BZ: 'country.bz',
  HT: 'country.ht',
  GD: 'country.gd',
  GF: 'country.gf',
  KN: 'country.kn',
  MQ: 'country.mq',
  AI: 'country.ai',
  GP: 'country.gp',
  DM: 'country.dm',
  MF: 'country.mf',
  VG: 'country.vg',
  VC: 'country.vc',
  CU: 'country.cu'
};
var _default = CountryCodes;
exports["default"] = _default;